module.exports = __webpack_public_path__ + "static/media/Game5.9ecad70f.svg";